import { TrackingEventKind } from '@today/types'
import { z } from 'zod'

/** Upper bound on a tracking token's length — a minted token is ~250 chars. */
export const TRACKING_TOKEN_MAX_LENGTH = 1024

/**
 * Body of the public landing beacon `POST /tr/events` (TO-165 REQ-003). Strict:
 * an extra property (e.g. a client-supplied `tenantId`) is refused, because
 * tenant, offer and render come ONLY from the verified token.
 */
export const trackingBeaconSchema = z
	.object({
		kind: z.enum(TrackingEventKind),
		token: z.string().min(1).max(TRACKING_TOKEN_MAX_LENGTH),
		sessionId: z.uuid(),
	})
	.strict()

export type TrackingBeaconInput = z.infer<typeof trackingBeaconSchema>
